export enum ActivityPurposeType {
  SUPPORT = '888b2265-1d3b-4aff-8e14-cd8a0e6d6555',
  NEW_CUSTOMER = '01b3300b-f827-46ed-9eeb-f0f7b5b2e430',
  NEW_OPPORTUNITY = '8540d2db-9a64-4a50-b2e9-e5b35f8b00e2',
  COLLECTION = '415b377a-41bf-4ab0-a19b-7cef2ab56f4b',
  PRICE_PASS = '67ff20c6-826e-43f7-b3a3-b292bd961244',
  MUTUAL_PAYMENT = 'ff55faf4-04eb-11ec-9a03-0242ac130003',
}
